import React from 'react';
import { Container, Paper, Title } from '@mantine/core';
import { ContactUsForm } from '@features/auth/contact-us/components/ContactUsForm';
import useStyles from './ContactUsLanding.styles';


export const ContactUsLanding: React.FC = () => {

    const { classes } = useStyles();

    return (
        <Container>
            <Paper className={classes.paper}>
                <Title mb={20} className={classes.h1} order={1}>
                    Contact Us
                </Title>

                {/*<Title className={classes.h2} order={2}>
                    Send us a message{' '}
                </Title>*/}
                <ContactUsForm/>
            </Paper>
        </Container>
    );

};
